import React from "react";
import { getFormattedNumber, getTotal } from "../utils/textUtils";
import { Link } from "react-router-dom";

const PurchaseByVendor = ({ resPacket, reportName }) => {
  const getNavigationLink = (reportName, a) => {
    if (reportName === "PurchaseByVender") {
      return (
        <Link to={`/purchase/${a.recordId}`} target="_blank">
          {a.purchaseOrderNo}
        </Link>
      );
    } else if (reportName === "GRNByVender") {
      return (
        <Link to={`/purchase/${a.purchaseOrderId}`} target="_blank">
          {a.purchaseOrderNo}
        </Link>
      );
    } else {
      return a.purchaseOrderNo;
    }
  };

  const getBillNavigationLink = (reportName, a) => {
    if (reportName === "GRNByVender") {
      return (
        <Link to={`/purchase/${a?.recordId}`} target="_blank">
          {a.billNo}
        </Link>
      );
    } else if (reportName === "PurchaseByVender") {
      return (
        <Link to={`/purchase/${a.purchaseOrderId}`} target="_blank">
          {a.billNo}
        </Link>
      );
    } else {
      return a.purchaseOrderNo;
    }
  };

  return resPacket?.length > 0 ? (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>ORDER DATE</td>
            <td>VENDOR NAME</td>
            {reportName === "GRN By Vendor" && <td>GRN NO.</td>}
            <td>ORDER NO.</td>
            <td>TOTAL AMOUNT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket.map((a, i) => (
            <tr key={i}>
              <td>{i+1}</td>
              <td>{a.purchaseOrderDate}</td>
              <td>{a.vendorTitle}</td>
              {reportName === "GRN By Vendor" && (
                <td>{getBillNavigationLink(reportName, a)}</td>
              )}
              {/* <td>{getBillNavigationLink(reportName, a)}</td> */}
              <td>{getNavigationLink(reportName, a)}</td>
              <td className="text-right">
                {" "}
                ₹ {getFormattedNumber(a.totalAmount)}
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={reportName === "GRN By Vendor" ? 4 : 3}>TOTAL:</td>
            <td className="text-right">
              ₹ {getFormattedNumber(getTotal(resPacket, "totalAmount"))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <>No Records Found</>
  );
};

export default PurchaseByVendor;
